import { render } from "./Typelist.vue?vue&type=template&id=16e7d02a&scoped=true"
import script from "./Typelist.vue?vue&type=script&lang=js"
export * from "./Typelist.vue?vue&type=script&lang=js"

import "./Typelist.vue?vue&type=style&index=0&id=16e7d02a&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e7d02a"]])

export default __exports__